<template>
  <div>
    <section class="feature-area section-padding2 toubugaodu"
      style=" height: 400px; background: url('../static/assets/images/bannerc.jpg') no-repeat;background-size: 100% auto;">
      <div class="container">
        <div class="row toubugaoduzt" style="height: 400px; line-height: 400px;color: #ffffff;font-size: 45px;">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <p style=" font-style: initial; ">关于我们</p>
            </div>
          </div>
        </div>

      </div>
      <div class="about_tab">
        <router-link class="about_tab_jj" to="/about" @click.native="reloadPage">企业简介</router-link>
        <router-link class="about_tab_wh" to="/wenhua" @click.native="reloadPage">企业文化</router-link>
        <router-link class="about_tab_jg" to="/jiagou" @click.native="reloadPage">企业架构</router-link>
        <router-link class="about_tab_zr" to="/zeren" @click.native="reloadPage"
          style="background: #0473db;color: #ffffff;">认证体系</router-link>
        <router-link class="about_tab_sm" to="/shengming" @click.native="reloadPage">版权声明</router-link>
      </div>
    </section>
    <section class="feature-area section-padding2 about_section1">
      <div class="container zerentoplist" style="padding-top: 100px;">
        <div class="row">
          <div class="col-lg-12">
            <!-- 
			{{aboutinfo.pics}}
			<p v-for="(item, index) in stringToArray(aboutinfo.pics)" :key="index">{{ item }}</p>
             -->
            <p v-html="aboutinfo.content"></p>
            <div v-for="(item, index) in stringToArray(aboutinfo.pics)" :key="index"
              class="single-job mb-4 d-lg-flex justify-content-between" style="padding:0px;">
              <div class="job-text  wow fadeInLeft animated zerenchongzu" style="padding: 40px 50px;">

                <h4 style="font-size: 18px;font-weight: 500;" class="zerenziti">
                  {{ stringToArrayshu(stringToArray(aboutinfo.picstitle)[index])[0] }}</h4>
                <ul class="mt-4 zerenkuan">
                  <li class="mb-3 zerentiku" style="color: #a89d99;">
                    {{ stringToArrayshu(stringToArray(aboutinfo.picstitle)[index])[1] }}
                    <br>
                    <span class="jiayige1"  style="color: #000000;line-height: 50px;">{{ stringToArrayshu(stringToArray(aboutinfo.picstitle)[index])[2] }}</span>
                  </li>
                  <li class=" buxianshi"
                    style="margin-top: 80px; width: 50px;height: 50px;line-height: 50px;text-align: center;font-size: 18px;background: #dddddd;color: #a89d99;">
                    ▷ </li>
                </ul>
              </div>
              <div class="job-img align-self-center wow zoomIn animated zerenimage">
                <img :src="newurl + item">
              </div>
            </div>

            <!-- <div class="single-job mb-4 d-lg-flex justify-content-between" style="padding:0px;">
			    <div class="job-text  wow fadeInLeft animated" style="padding: 40px 50px;">
			        <h4 style="font-size: 28px;font-weight: 500;">员工责任</h4>
			        <ul class="mt-4">
			          <li class="mb-3" style="color: #a89d99;">以人为本 人尽其才</li>
			          <li style="margin-top: 80px; width: 50px;height: 50px;line-height: 50px;text-align: center;font-size: 18px;background: #dddddd;color: #a89d99;"> ▷ </li>
			        </ul>
			      </div>
			  <div class="job-img align-self-center wow zoomIn animated">
			    <img src="static/assets/images/zeren02.jpg">
			  </div>
			</div>
			
			<div class="single-job mb-4 d-lg-flex justify-content-between" style="padding:0px;">
			    <div class="job-text  wow fadeInLeft animated" style="padding: 40px 50px;">
			        <h4 style="font-size: 28px;font-weight: 500;">行业责任</h4>
			        <ul class="mt-4">
			          <li class="mb-3" style="color: #a89d99;">引领创新 发展共赢</li>
			          <li style="margin-top: 80px; width: 50px;height: 50px;line-height: 50px;text-align: center;font-size: 18px;background: #dddddd;color: #a89d99;"> ▷ </li>
			        </ul>
			      </div>
			  <div class="job-img align-self-center wow zoomIn animated">
			    <img src="static/assets/images/zeren03.jpg">
			  </div>
			</div>
			
			<div class="single-job mb-4 d-lg-flex justify-content-between" style="padding:0px;">
			    <div class="job-text  wow fadeInLeft animated" style="padding: 40px 50px;">
			        <h4 style="font-size: 28px;font-weight: 500;">环保责任</h4>
			        <ul class="mt-4">
			          <li class="mb-3" style="color: #a89d99;">节能环保 低碳降耗</li>
			          <li style="margin-top: 80px; width: 50px;height: 50px;line-height: 50px;text-align: center;font-size: 18px;background: #dddddd;color: #a89d99;"> ▷ </li>
			        </ul>
			      </div>
			  <div class="job-img align-self-center wow zoomIn animated">
			    <img src="static/assets/images/zeren04.jpg">
			  </div>
			</div>
			
			<div class="single-job mb-4 d-lg-flex justify-content-between" style="padding:0px;">
			    <div class="job-text  wow fadeInLeft animated" style="padding: 40px 50px;">
			        <h4 style="font-size: 28px;font-weight: 500;">客户责任</h4>
			        <ul class="mt-4">
			          <li class="mb-3" style="color: #a89d99;">创造价值 高质服务</li>
			          <li style="margin-top: 80px; width: 50px;height: 50px;line-height: 50px;text-align: center;font-size: 18px;background: #dddddd;color: #a89d99;"> ▷ </li>
			        </ul>
			      </div>
			  <div class="job-img align-self-center wow zoomIn animated">
			    <img src="static/assets/images/zeren05.jpg">
			  </div>
			</div>
			
			<div class="single-job mb-4 d-lg-flex justify-content-between" style="padding:0px;">
			    <div class="job-text  wow fadeInLeft animated" style="padding: 40px 50px;">
			        <h4 style="font-size: 28px;font-weight: 500;">公益责任</h4>
			        <ul class="mt-4">
			          <li class="mb-3" style="color: #a89d99;">社会保障 慈善教育</li>
			          <li style="margin-top: 80px; width: 50px;height: 50px;line-height: 50px;text-align: center;font-size: 18px;background: #dddddd;color: #a89d99;"> ▷ </li>
			        </ul>
			      </div>
			  <div class="job-img align-self-center wow zoomIn animated">
			    <img src="static/assets/images/zeren06.jpg">
			  </div>
			</div> -->

          </div>
        </div>

      </div>
    </section>
    <!-- Feature Area End -->



  </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      aboutinfo: [],
      newurl: 'https://naduapi.jurenkeji.com.cn',
    };
  },
  mounted() {
    //公司信息
    axios.postForm('https://naduapi.jurenkeji.com.cn/api.php/about/24', {
      appid: 'jurenkeji2024',
      timestamp: '1722845854',
      signature: '0eb76b812e96966c380b90c6e7416a26'
    })
      .then(response => {
        console.log(response.data.data);
        this.aboutinfo = response.data.data;

      })
      .catch(error => {
        console.error('当前网络环境异常!', error);
      });
  },
  methods: {
    reloadPage() {
      // console.log('3333')
      // 如果不是因为导航重复而出现错误，则重新加载页面
      window.location.reload()
    },
    // 截取新闻标题字符串至指定长度
    truncatecontent(dateStr, length = 4) {
      return dateStr.substring(0, length);
    },
    stringToArray(str) {
      // 使用 split 方法将字符串按逗号分割成数组
      return str.split(',');
    },

    stringToArrayshu(str) {
      // 使用 split 方法将字符串按逗号分割成数组
      return str.split('|');
    },

    truncatecontentb(dateStr, length = 20) {
      return dateStr.substring(4, length);
    },


  }
};
</script>


// WEBPACK FOOTER //
// Zeren.vue?7e9ffbff